"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSelectableTestNode = isSelectableTestNode;
exports.isTestOptionGroup = isTestOptionGroup;
const constants_1 = require("../constants");
function isSelectableTestNode(node) {
    return [
        constants_1.TestHierarchyNodeType.TEST,
        constants_1.TestHierarchyNodeType.RADIO_OPTION,
        constants_1.TestHierarchyNodeType.CHECKBOX_OPTION,
    ].includes(node.nodeType);
}
function isTestOptionGroup(node) {
    return [
        constants_1.TestHierarchyNodeType.TEST_GROUP_OPTION_CHECKBOX_GROUP,
        constants_1.TestHierarchyNodeType.TEST_GROUP_OPTION_RADIO_GROUP,
        constants_1.TestHierarchyNodeType.TEST_OPTION_RADIO_GROUP,
        constants_1.TestHierarchyNodeType.TEST_ADDITIONAL_OPTION_GROUP,
    ].includes(node.nodeType);
}
